interface DisplayPriceItem {
  price?: number;
  wholesalePrice?: number;
  amount: number;
  subUnitQty: number;
  lineDiscount?: unknown;
  aftercare?: { discountedSource?: unknown };
  priceLabel?: string;
}

// Sales show the original price; discounted refunds retain their allocated refund price.
export function salesDisplayUnitPrice(item: DisplayPriceItem, referencePrice = item.price ?? item.wholesalePrice ?? 0): number {
  const discounted = item.aftercare?.discountedSource || item.priceLabel === '优惠退货';
  if (discounted && Number.isFinite(item.amount) && Number.isFinite(item.subUnitQty) && item.subUnitQty > 0) {
    return Math.round((item.amount / item.subUnitQty + Number.EPSILON) * 100) / 100;
  }
  return referencePrice;
}
